import NavigationIcon from "./NavigationIcon"

const NavigationTabIcon = NavigationIcon.extend`
  padding-bottom: 20px;
  flex-grow: 1;
`

export default NavigationTabIcon



// WEBPACK FOOTER //
// ./src/Kiosk/Navigator/NavigationTabIcon.js